import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Arrow from '../../assets/right-arrow-long.inline.svg';

const Holder = styled.span`
  display: flex;
  align-items: center;
  font-style: italic;
  svg {
    height: 0.5rem;
    width: auto;
    margin-left: 0.5rem;
    margin-top: 0.2rem;
    transition: transform 0.25s;
  }
  &:hover svg { transform: translateX(0.2rem); }
`;

function LongArrowLink( { to, text } ) {
  return (
    <Holder>
      <Link to={to}><span>{text}</span><Arrow/></Link>
    </Holder>
  )
}

LongArrowLink.propTypes = {
  to: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default LongArrowLink;
